<template>
  <div class="flex justify-content-center">
    <Dropdown
      :value="currentLanguage?.language"
      :options="languageLinks"
      :placeholder="currentLanguage?.label"
      optionLabel="label"
      class="border-none text-sm text-royal-400 w-full md:w-14rem"
      @update:modelValue="onChangeLanguage"
    />
  </div>
</template>

<script setup lang="ts">
import { ref, computed, watch } from 'vue'
import { useI18n } from 'vue-i18n'
import { saveLocale } from '@lingoking-node-apps/i18n'
import Dropdown from 'primevue/dropdown'

const { locale } = useI18n()

const languageLinks = ref([
  {
    label: 'EN',
    language: 'en'
  },
  {
    label: 'DE',
    language: 'de'
  }
])

const currentLanguage = computed(() => {
  return languageLinks.value.find((lang) => locale.value == lang.language)
})

const onChangeLanguage = ({ language }: any) => {
  locale.value = language
}

watch(locale, () => {
  locale.value = saveLocale(locale.value)

  window.location.reload()
})
</script>
